/**
 * @fileoverview Vuex getters for Watson Assistant computed state.
 *
 * @module store/modules/watson/getters
 *
 * Provides computed values for:
 * - Watson intents
 * - Watson entities
 * - Watson dialog nodes
 * - Edit tracking state
 */

import { GetterTree } from "vuex/types";
import { RootState } from "@/store/types";
import { WatsonState } from "./types";

const getters: GetterTree<WatsonState, RootState> = {
  /**
   * Gets all Watson intents.
   *
   * @returns Array of Watson intents
   */
  watsonIntents: (state, getters, rootState) => {
    return state.intents;
  },
  /**
   * Gets all Watson entities.
   *
   * @returns Array of Watson entities
   */
  watsonEntities: (state, getters, rootState) => {
    return state.entities;
  },
  /**
   * Gets all Watson dialog nodes.
   *
   * @returns Array of dialog nodes
   */
  watsonDialogNodes: (state, getters, rootState) => {
    return state.dialogNodes;
  },
  /**
   * Gets edit tracking state for Watson nodes.
   *
   * @returns Object mapping node types to their edit state
   */
  watsonisEditedObject: (state, getters, rootState) => {
    return state.isEditedObject;
  },
};

export default getters;
